// extracted by mini-css-extract-plugin
module.exports = {"component":"media-slider-item_component__gVJdZ","button":"media-slider-item_button__siuPs","imageWrapper":"media-slider-item_imageWrapper__s4RKT"};